import { FC } from 'react'
import Balance from '../components/Balance/Balance';

const BalancePage: FC = () => {
    return (
        <div className='w-full'>
            <div>
                <Balance />
            </div>
        </div>
    )
}

export default BalancePage;